import { render, staticRenderFns } from "./edasComponent.vue?vue&type=template&id=283da856&scoped=true"
import script from "./edasComponent.vue?vue&type=script&lang=js"
export * from "./edasComponent.vue?vue&type=script&lang=js"
import style0 from "./edasComponent.vue?vue&type=style&index=0&id=283da856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283da856",
  null
  
)

export default component.exports